// 🔍 Estado de la paleta de comandos (Ctrl/⌘ + K).
// Es sólo un interruptor, pero vive en un store para que el botón del Header y
// el atajo de teclado abran LA MISMA paleta sin pasar props por el AppShell, y
// para que mañana cualquier pantalla pueda abrirla sin tocar el layout.
import { create } from 'zustand';

interface PaletaStore {
  abierta: boolean;
  abrir: () => void;
  cerrar: () => void;
  alternar: () => void;
}

export const usePaletaStore = create<PaletaStore>((set) => ({
  abierta: false,
  abrir: () => set({ abierta: true }),
  cerrar: () => set({ abierta: false }),
  alternar: () => set((s) => ({ abierta: !s.abierta })),
}));
